/**
 * Reduced-motion guard for inline illustration SVGs.
 *
 * Inline SVGs animate via SMIL, which CSS media queries can't gate. So when the
 * visitor prefers reduced motion, freeze each illustration at its initial
 * (dot-free) frame.
 */
((Drupal) => {
  Drupal.behaviors.rhinoIllustration = {
    attach(context) {
      const svgs = once('rh-illustration', '.rh-illustration svg', context);
      if (!svgs.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        svgs.forEach((svg) => {
          try {
            svg.setCurrentTime(0);
            svg.pauseAnimations();
          } catch (e) {
            // Non-animated SVG — nothing to pause.
          }
        });
      }
    },
  };
})(Drupal);
